<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro Multirriesgo Copropiedades</h1>
                <p>¿Alguna vez ha pensado cómo respaldar su bien raíz ante incendio, rayo, explosión,
                deslizamiento, terremoto, erupción volcánica, entre otros riesgos que le pueden ocasionar
                daños? Invertir en su seguridad es esencial.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Al adquirir este seguro usted podrá:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Según la Ley 675 de 2001, toda propiedad horizontal, es decir perteneciente a dos o más
                dueños, está en la responsabilidad de adquirir un seguro que ampare los bienes comunes
                de riesgos como incendio, terremoto u otros sucesos que perjudiquen la estabilidad y
                tranquilidad de quienes ocupan temporal o permanentemente el inmueble.
                Proteger las copropiedades comerciales o industriales, y sus zonas comunes, es muy fácil
                con el Seguro Multirriesgo Copropiedades, Olvídese de las preocupaciones que puede
                ocasionarle como copropietario o administrador el enfrentarse de forma imprevista a daños
                materiales.
                <span>Su patrimonio queda en las mejores manos con nosotros. ¡No espere para asegurar su
                copropiedad e invertir 100 % en su seguridad!</span></p>
            </center>
            <center class="box-title"><h1>¿De qué trata el Seguro Multirriesgo Copropiedades?</h1></center>
            <center class="box">
                <p>Es una solución integral para reparar los daños o pérdidas materiales a los que se vea
                expuesto su edificio o copropiedad. Al contar con este respaldo, usted y los demás
                copropietarios podrán disminuir estratégicamente cualquier riesgo que deteriore su
                patrimonio.</p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Cuál es el valor asegurado?</h1>
            <p>Es el valor de reconstrucción a nuevo de los bienes comunes de la coporpiedad
            entendiéndose como la cantidad de dinero requerida para reconstruir un inmueble de tal
            manera que sea de la misma naturaleza y tipo, y que recupere las características de
            funcionalidad.</p>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'

export default {
    name: 'Multiriesgo-Copropiedades',
    metaInfo() {
        return {
            title: 'Seguro Multirriesgo Copropiedades',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: '¿Alguna vez ha pensado cómo respaldar su bien raíz ante incendio, rayo, explosión, deslizamiento, terremoto, erupción volcánica, entre otros riesgos que le pueden ocasionar daños? Invertir en su seguridad es esencial.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados
    },
    data() {
        return {
            services: [
                {
                    type: true,
                    img: require('@/assets/Empresariales-Multirriesgo-Copropiedades/4.png'),
                    label: '¿Qué cubrimos?',
                    p: [
                        'Incendio, rayo y el calor y el humo producidos por estos hechos.',
                        'Explosión ocurrida dentro o fuera de la copropiedad.',
                        'Huracán, tornado, vientos fuertes y granizo.',
                        'Daños ocasionados por exceso de agua y avalancha.',
                        'Asentamientos, deslizamientos, hundimientos de terreno, derrumbes y desprendimiento de tierra o roca.',
                        'Terremoto, temblor de tierra, erupción volcánica, maremoto o tsunami.',
                        'Impacto de vehículos terrestres o caída de aeronaves u objetos que se desprendande ellas.',
                        'Riesgos sujetos al funcionamiento de maquinaria y equipos, tales como sabotaje por parte de personal interno o ajeno a la propiedad.'
                    ]
                },
                {
                    type: false,
                    img: require('@/assets/Empresariales-Multirriesgo-Copropiedades/5.png'),
                    label: '¿Qué no cubrimos?',
                    p: [
                        'Guerra, invasión, actos de enemigos extranjeros, hostilidades u operaciones bélicas (exista o no declaración de guerra).',
                        'Embargos, secuestros, sanciones civiles, allanamientos, confiscaciones, decomisos, expropiaciones y similares.',
                        'Riesgos nucleares y atómicos.',
                        'Contaminación biológica, química, ambiental o por radioactividad.',
                        'Daño o pérdida material causada directa o indirectamente por cohetes o misiles.',
                        'Fraude por parte suya como asegurado.',
                        'Daños estéticos sobre bienes materiales como rasguños, manchas o rayones.',
                        'Cualquier daño ocasionado por enfermedades infecciosas o contagiosas.'
                    ]
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Tener la posibilidad de escoger el profesional de su preferencia.',
                            img: require('@/assets/Empresariales-Multirriesgo-Copropiedades/1.png')
                        },
                        {
                            text: 'Extender la protección a su grupo familiar.',
                            img: require('@/assets/Empresariales-Multirriesgo-Copropiedades/2.png')
                        },
                        {
                            text: 'Pagar una tarifa estable a lo largo de la vida laboral.',
                            img: require('@/assets/Empresariales-Multirriesgo-Copropiedades/3.png')
                        }
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/MultirriesgoCopropiedades.vue